import React from "react";
import { Grid, Divider } from "@material-ui/core";
import { InputOptionMaster, InputTextMaster } from "App/Component/ui";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { RESET_STATE_FORM_FILTER } from "./helpers";
import { InventoryButtonAction } from "components/organism";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";

export default function FormFilterDaftarInventoryControl({
  formFilter,
  setFormFilter,
  setNewData,
  handleClickAdd,
}) {
  // const [gudangIsNotDisabled, setGudangIsNotDisabled] = useState([]);

  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const gudangUtama = useSelectOption(
    true,
    LIST_URL_WAREHOUSE.masterGudangPBF.getGudang,
    TYPE_INSTANCE4,
    "gudangId",
    "name",
    "data"
  );

  // useEffect(() => {
  //   async function setGudang() {
  //     const response = await getAccessUser(GUDANG_ACCESS_CODE);
  //     if (response.state) {
  //       // setGudangIsNotDisabled(response.data);
  //       setFormFilter({
  //         ...formFilter,
  //         gudang_id: response.data[0],
  //       });
  //       await setNewData(formFilter.pages, formFilter.limit, {
  //         barang_name: "",
  //         gudang: "Pilih Gudang",
  //         gudang_id: response.data[0],
  //       });
  //     } else {
  //       // setGudangIsNotDisabled([]);
  //       await setNewData();
  //     }
  //   }

  //   setGudang();
  // }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Grid container spacing={1}>
        <Grid item sm={6}>
          <InputTextMaster
            name='barang_name'
            label='NAMA BARANG'
            id='barang_name'
            value={formFilter.barang_name}
            onChange={handleChange("barang_name")}
            placeholder='Nama Barang'
          />
        </Grid>
        <Grid item sm={6}>
          <InputOptionMaster
            name='gudang_id'
            label='GUDANG FARMASI'
            id='gudang_id'
            withSearch={true}
            data={gudangUtama}
            value={formFilter.gudang_id}
            labelValue={formFilter.gudang}
            // optionIsNotDisabled={gudangIsNotDisabled}
            // isSpecificDisabled={true}
            onChange={(e) =>
              setFormFilter({
                ...formFilter,
                gudang_id: e?.value,
                gudang: e?.label,
              })
            }
          />
        </Grid>
      </Grid>
      <br />

      <InventoryButtonAction
        handleClikReset={() => setFormFilter(RESET_STATE_FORM_FILTER)}
        handleClickAdd={handleClickAdd}
        isExport={true}
        formFilter={formFilter}
        urlExport={"/wmsfarmasi/inventory/list-export"}
        titelExportModal={"Export List Inventory Perbekalan Farmasi"}
        type={"inventoryControlFarmasi"}
        handleSubmit={handleSubmit}
        withImport={true}
        setNewDataImport={setNewData}
      />

      <br />
      <Divider />
    </>
  );
}
